




module.exports =
	props: ["totalPages"]
	computed:
		pageName: -> return this.$route.name
		pageNo: -> return this.$route.params.page
		category: -> return this.$route.params.category
	methods:
		renderText: (strJa, strEn) -> return if !this.isEnglish then strJa else strEn
		pageJump: (page) ->
			if page is this.pageNo then return
			newParams = this.$route.params
			newParams.page = page
			this.$router.replace({name: this.pageName, params: newParams})



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/archive/pagenation.vue